var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangetick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.29193C0 6.09277 0.873611 3.98369 2.42865 2.42865C3.98369 0.873611 6.09277 0 8.29193 0C10.4911 0 12.6002 0.873611 14.1552 2.42865C15.7102 3.98369 16.5839 6.09277 16.5839 8.29193C16.5839 10.4911 15.7102 12.6002 14.1552 14.1552C12.6002 15.7102 10.4911 16.5839 8.29193 16.5839C6.09277 16.5839 3.98369 15.7102 2.42865 14.1552C0.873611 12.6002 0 10.4911 0 8.29193H0ZM7.81873 11.8409L12.5927 5.87289L11.7303 5.18301L7.65953 10.2698L4.77615 7.86738L4.06857 8.71647L7.81873 11.842V11.8409Z",
    fill: "#002e6e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangetick);
export default __webpack_public_path__ + "static/media/orangetick.10bf280b1925cc2d44d1c9f169718ac3.svg";
export { ForwardRef as ReactComponent };